import {
    sourceCancelModelUpdate,
    sourceApplyModelUpdate
} from "../../../../actions/source-actions"

import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    sourceApplyModelUpdate,
    sourceCancelModelUpdate,
    "sources"
)
